<template>
    <div class="coupons-container">
        <div class="list" v-for="(item, index) in list" :key="index">
            <div
                :class="['tags', 'qyr_' + item.requiredScore]"
                v-show="content.activityStatus === 10"
            ></div>
            <div class="title">
                <template v-if="item.awardType === 0">
                    <span>{{ item.couponAmount / 100 }}元</span>
                    <span class="title-des">{{ item.title }}</span>
                </template>
                <template v-else>
                    <span>{{ item.couponDiscount }}折</span>
                    <span class="title-des">{{ item.title }}</span>
                </template>
            </div>
            <div class="desc">{{ item.simpleDesc }}</div>
            <div @click="seckillBtnClick(item)" :class="getBtnCls(item)">
                {{ btnStatus(item) }}
            </div>
            <div class="residue" v-if="isShowBottomDesc(item)">
                {{ couponsCountDesc(item) }}
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'seckill-coupons',
    props: {
        list: {
            type: Array,
            default: [],
        },
        content: {
            type: Object,
            default: {},
        },
    },
    data() {
        return {};
    },
    methods: {
        seckillBtnClick(item) {
            this.$emit('seckillBtnClick', item);
        },
        getBtnCls(item) {
            if (!this.content.isOldCustomer) {
                return 'btn';
            } else {
                if (item.awardStatus === 0) {
                    return 'btn';
                } else if (item.awardStatus === 1) {
                    return 'btn-gray';
                } else if (item.awardStatus === 3) {
                    return 'btn-gray';
                } else if (item.awardStatus === 10) {
                    return 'btn';
                } else if (item.awardStatus === 20 || item.awardStatus === 21) {
                    return 'btn';
                } else if (item.awardStatus === 20 || item.awardStatus === 21) {
                    return 'btn';
                } else if (item.awardStatus === 22) {
                    return 'btn-gray';
                } else {
                    return 'btn';
                }
            }
        },

        isShowBottomDesc(item) {
            if (this.content.activityStatus === 10) {
                // 活动已开始
                if (item.surplusNum === 0) {
                    // 剩余0
                    return false;
                } else {
                    if (item.awardStatus === 20) {
                        // 已领取
                        return false;
                    }
                    return true;
                }
            } else {
                // 活动未开始
                if (item.awardStatus === 0) {
                    return true;
                }
                return false;
            }
        },
        couponsCountDesc(item) {
            if (this.content.activityStatus === 10) {
                // 活动已开始
                if (item.surplusNum === 0) {
                    // 已抢完
                    return '';
                }
                return `剩余${item.surplusNum}张`;
            } else {
                if (!this.content.isOldCustomer) {
                    return `激活可领`;
                }
                return `${item.requiredScore}活力值可领`;
                // return '';
            }
        },
        btnStatus(item) {
            if (!this.content.isOldCustomer) {
                if (this.content.activityStatus === 10) {
                    return '激活可领';
                }
                return '去激活';
            } else {
                if (item.awardStatus === 0) {
                    // if (this.content.level === 'V0') {
                    // } else {
                    //     return `升至${item.requiredLevel}可领`;
                    // }
                    if (this.content.activityStatus === 10) {
                        return '升级可领';
                    }
                    return '去升级';
                } else if (item.awardStatus === 1) {
                    return '等待开始';
                } else if (item.awardStatus === 3) {
                    return '已抢完';
                } else if (item.awardStatus === 10) {
                    return '立即领券';
                } else if (item.awardStatus === 20 || item.awardStatus === 21) {
                    return '去使用';
                } else if (item.awardStatus === 22) {
                    return '已使用';
                } else {
                    return '';
                }
            }
        },
    },
};
</script>
<style lang="less" scoped>
@import '~@common/style/common.less';
.coupons-container {
    margin: auto;
    width: 100%;
    height: 100%;
    position: relative;
    padding-bottom: 28px;
    margin-top: -5px;

    .list {
        width: 329px;
        height: 98px;
        .backgroundImage(329px, 98px, '~@assets/img/qyr_quan_bg@2x.png');
        margin: auto;
        margin-top: 16px;
        position: relative;
        .tags {
            background-size: 100% 100%;
        }
        .qyr_100 {
            .backgroundImage(83px, 19px, '~@assets/img/qyr_V0@2x.png');
        }
        .qyr_300 {
            .backgroundImage(83px, 19px, '~@assets/img/qyr_V1@2x.png');
        }
        .qyr_600 {
            .backgroundImage(83px, 19px, '~@assets/img/qyr_V2@2x.png');
        }
        .qyr_1100 {
            .backgroundImage(83px, 19px, '~@assets/img/qyr_V3@2x.png');
        }
        .btn {
            .f-12-bold();
            color: #9f5c19;
            line-height: 31px;
            width: 82px;
            height: 28px;
            text-align: center;
            background: linear-gradient(
                270deg,
                rgba(255, 191, 53, 1) 0%,
                rgba(255, 211, 116, 1) 100%
            );
            border-radius: 18px;
            position: absolute;
            top: 35px;
            right: 22px;
        }
        .btn-gray {
            .f-12-bold();
            color: rgba(255, 255, 255, 1);
            line-height: 31px;
            width: 83px;
            height: 29px;
            text-align: center;
            background: #c1c1c1;
            border-radius: 18px;
            position: absolute;
            top: 35px;
            right: 22px;
        }
        .residue {
            position: absolute;
            top: 69px;
            right: 5px;
            .f-10-bold();
            width: 115px;
            text-align: center;
            color: #b9722c;
            line-height: 14px;
        }
        .title {
            span {
                color: #e2430d;
                .f-24-bold();
            }
            .title-des {
                color: #b9722c;
                margin-left: 3px;
                .f-14-bold();
            }
            color: #b9722c;
            position: absolute;
            top: 39px;
            left: 35px;
            height: 18px;
            .f-14-bold();
            line-height: 18px;
        }
        .desc {
            position: absolute;
            top: 69px;
            left: 35px;
            font-size: 11px;
            font-family: fzlt;
            color: #b9722c;
            line-height: 14px;
        }
    }
}
</style>
